import { Inbox, RefreshCcw, ServerOff } from 'lucide-react';

export function LoadingState({ label = 'Загружаем данные…' }: { label?: string }) {
  return (
    <div className="loading-state" aria-busy="true" aria-live="polite">
      <div className="skeleton skeleton--title" />
      <div className="skeleton-grid">
        {Array.from({ length: 6 }, (_, index) => (
          <div className="skeleton-card" key={index}>
            <div className="skeleton skeleton--line skeleton--short" />
            <div className="skeleton skeleton--metric" />
            <div className="skeleton skeleton--line" />
          </div>
        ))}
      </div>
      <span className="sr-only">{label}</span>
    </div>
  );
}

interface StatePanelProps {
  kind: 'empty' | 'error';
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
}

export function StatePanel({ kind, title, description, actionLabel, onAction }: StatePanelProps) {
  const Icon = kind === 'error' ? ServerOff : Inbox;
  return (
    <section className="state-panel" role={kind === 'error' ? 'alert' : 'status'}>
      <span className="state-panel__icon" aria-hidden="true">
        <Icon size={26} />
      </span>
      <h2>{title}</h2>
      <p>{description}</p>
      {actionLabel && onAction && (
        <button className="button button--secondary" type="button" onClick={onAction}>
          <RefreshCcw size={17} aria-hidden="true" />
          {actionLabel}
        </button>
      )}
    </section>
  );
}
